<template>
  <v-col class="justify-center body-1">
    <v-row justify="space-between" align="center" class="my-6 mr-0">
      <v-col>{{ $t("Change password") }}</v-col>
      <v-col>
        <v-btn outlined color="primary" @click="showChangePasswordDialog">{{ $t("Update") }}</v-btn>
      </v-col>
    </v-row>
    <v-row justify="space-between" align="center">
      <v-col>
        {{
        $t(
        "Receive email about your MerloCode activity, recommendations and news"
        )
        }}
      </v-col>
      <v-col>
        <v-checkbox v-model="settings.mailSubscription" />
      </v-col>
    </v-row>
    <v-row justify="space-between" align="center">
      <v-col>{{ $t("Inclúyeme en pruebas y avances") }}</v-col>
      <v-col>
        <v-checkbox v-model="settings.tester" />
      </v-col>
    </v-row>
    <v-row justify="space-between" align="center" class="my-6 mr-0">
      <v-col>{{ $t("Billing") }}</v-col>
      <v-col>
        <v-btn outlined color="primary" @click="billing">{{ $t("Billing Data") }}</v-btn>
      </v-col>
    </v-row>
    <v-row justify="space-between justify-end" align="end" class="mr-0">
      <v-col>
        <div>{{ $t("Delete account") }}</div>
      </v-col>
      <v-col>
        <v-btn outlined color="red" @click="showConfirmDeleteAccountDialog">{{ $t("Delete") }}</v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="changePasswordDialog" width="45vw">
      <ChangePasswordDialog v-if="changePasswordDialog" @close="closeChangePasswordDialog" />
    </v-dialog>
    <v-dialog v-model="confirmDeleteAccountDialog" width="40vw">
      <DeleteAccountDialog
        v-if="confirmDeleteAccountDialog"
        @close="closeConfirmDeleteAccountDialog"
      />
    </v-dialog>
  </v-col>
</template>

<script>
import ChangePasswordDialog from "@/views/dashboard/components/settings/ChangePasswordDialog";
import DeleteAccountDialog from "@/views/dashboard/components/settings/DeleteAccountDialog";
import http from "@/service/http";

export default {
  props: ["settings"],

  components: { ChangePasswordDialog, DeleteAccountDialog },

  data() {
    return {
      changePasswordDialog: false,
      confirmDeleteAccountDialog: false
    };
  },

  methods: {
    async billing() {
      let urlCreateStripeSesion = "plans/portal";
      let response = await http.get(urlCreateStripeSesion);
      window.location.href = response.data.url;
    },
    showChangePasswordDialog() {
      this.changePasswordDialog = true;
    },
    closeChangePasswordDialog() {
      this.changePasswordDialog = false;
    },
    showConfirmDeleteAccountDialog() {
      this.confirmDeleteAccountDialog = true;
    },
    closeConfirmDeleteAccountDialog() {
      this.confirmDeleteAccountDialog = false;
    }
  }
};
</script>

<style></style>
